import React from "react";
import { fetchSubscribeToPet, deleteSubscriber, updateSubscribedToPet } from "../../../actions/subscribeToPet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import Responsive from "react-responsive";
import config from "../../../config";
import _ from "lodash";
import Store from "../../../store";
import { changeDateFormat } from "../../../utils/helper";
import MessageToSubscribers from "../../../components/dataModal/messageToSubscribers";
import Select from "react-select";


const $ = window.$;
const { SearchBar } = Search;

const petAvailabilityStatus = {
  available: "available",
  sold: "sold",
};

let timeOptions = [{ label: "This Week", value: "this_week" },
{ label: "Last Week", value: "last_week" },
{ label: "All", value: "all" }];

const TIMEDURATION = {
  THIS_WEEK : 'this_week',
  LAST_WEEK : 'last_week',
  ALL : 'all',
};

const orientation = window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal";

const userPermissionList = {
  listSocialMediaSubmission : 'list-social-media-submission',
};

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    socialMediaSubmissions: [],
    listSocialMediaSubmissionFlag:[],
    loadingDelete: false,
    deleteId: false,
    selectedTab: "mobileNo",
    messageSubscribers: false,
    loadingBd : true,
    timeDuration : 'this_week',
    timeFilterType : {},
    subscribedToPetId : '',
    subscribedNotes : '',
    loadingSubscribedToPetsUpdate : false,

  };

  tableHeaderTopColumnData= [
    {
      dataField: "mobileNo",
      text: "Mobile No",
      sort: true,
      formatter: (cell) => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>,
    }
  ];

  tableHeaderTopPetColumnData= [
    {
      dataField: "pet_id",
      text: "Pet Id",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div style={{width: 150}}>
              <span className="m-topbar__userpic">
                <img
                  src={
                    process.env.REACT_APP_S3_PATH +
                    "/" +
                    row.avatar_path +
                    "/" +
                    row.avatar_file_name
                  }
                  className="m--img-rounded m-width-50 mr-2"
                  alt=""
                />    
              { this.props.data.petShopReducer.currentPetshop && this.props.data.petShopReducer.currentPetshop.id && row.MedicalRecordId ?
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.MedicalRecordId}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
               >
                <span className="m-badge m-badge--info mx-auto my-0 px-2">
                  <strong>{cell}</strong>
                </span>
             </a> :
              <span className="m-badge m-badge--info mx-auto my-0 px-2">
                <strong>{cell}</strong>
              </span> 
              }
              </span> 
          </div>
        );
      
      }
    }
  ];

  tableHeaderTopBreedColumnData= [
    {
      dataField: "breed_name",
      text: "Breed Name",
      sort: true,
    }
  ];

  tableHeaderColumnData = [ 
    {
      dataField: "MedicalRecord.pet_id",
      text: "Pet ID",
      sort: true,
      headerStyle: (selector, id) => {
        return { textAlign: "center", width: "95px" };   // removed partial line here
      }
    },
    {
      dataField: "MedicalRecord.Breed.breed_type",
      text: "Breed",
      sort: true,
      formatter: (cell) => cell
    },
    {
      dataField: "mobileNo",
      text: "Mobile No",
      sort: true,
      formatter: (cell) => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "notifyChanges",
      text: "Notify Changes",
      sort: true,
      formatter: (cell) => cell ? "subscribed" : "unsubscribed",
    },
    {
      dataField: "notifyNewArrivals",
      text: "Notify New Arrivals",
      sort: true,
      formatter: (cell) => cell ? "subscribed" : "unsubscribed",
    },
    {
      dataField: "notes",
      text: "Notes",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
            {cell ? <span style={{color: "#f00"}}>{cell} <br/></span> : ""}
            Notified count : {row.SubscribeNotifications ? row.SubscribeNotifications.length: 0}
          </div>
        );
      }  
    },{
      dataField: "createdAt",
      text: "Submitted Date",
      sort: true,
      headerStyle: (selector, id) => {
        return { textAlign: "center", width: "110px" };   // removed partial line here
      },
      formatter: (cell) => changeDateFormat(moment(cell).format("YYYY-MM-DD"), "YYYY-MM-DD", "MM-DD-YYYY" ) 
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      headerStyle: (selector, id) => {
        return { textAlign: "center", width: "110px" };   // removed partial line here
      },
      formatter: (cell, row) => {
        return (
          <div>
            {cell === "Success" ? 
                <span class="m-badge m-badge--success mx-auto my-0 px-4">{cell}</span>
            : ""    
            }

            {cell === "Pending" ? 
                <span class="m-badge m-badge--warning mx-auto my-0 px-4">{cell}</span>
            : ""    
            }


            {cell === "Stop" ? 
                <span class="m-badge m-badge--danger mx-auto my-0 px-4">{cell}</span>
            : ""    
            }


          </div>
        );
      }  
    },
    {
      dataField: 'contactNotes',
      text: 'Contact Notes',
      sort: true,
      formatter: (cell, row) => {
        return ( 
        <div>
          <a
           href=""
           onClick={(e) => {this.openNotesEditModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
             {cell}
             <i className="la la-edit"></i>
          </a>
        </div>
        );
      }
    },
    {
      text: "Action",
      sort: true,
      headerStyle: (selector, id) => {
        return { textAlign: "center", width: "60px" };   // removed partial line here
      },
      formatter: (cell, row) => {
        return (
          <div>
            
            <button class="btn btn-outline-danger btn-sm" onClick={() => this.openConfirmModel(row.id)}><i class="las la-trash"></i></button>

          </div>
        );
      }    
    }
  ];

  expandRow = {
    renderer: (row, rowIndex) => (  
      <div>            
                   <ToolkitProvider
                       keyField="id"
                       data={ row.rows }
                       columns={this.tableHeaderColumnData}
                       search
                       hover={true}
                       filter={filterFactory()} 
                       
                                       
                     >
                       {props => (
                         <div>  
                                                      
                             <BootstrapTable  
                              classes="breedersPuppyChildTable"                          
                               {...props.baseProps}                        
                      
                             />  
                        </div>                      
                     
                       )}
                     </ToolkitProvider>  
               </div>
   ),
     showExpandColumn: true ,
     expandHeaderColumnRenderer: ({ isAnyExpands }) => {
             if (isAnyExpands) {
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
             }
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
           },
     expandColumnRenderer: ({ expanded }) => {
             if (expanded) {
               return (
                 <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
               );
             }
             return (
               <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
             );
           }
  };

  componentDidMount() {   
    this.loadPermissions();
    this.loadSubscribeToPetByTime(this.props.match.params.option);
  }



  loadPermissions(){  
    let allPermission = JSON.parse( localStorage.getItem('userPermissions')) ; 
      if(allPermission && allPermission.length > 0){ 
          const listSocialMediaSubmission =  allPermission.find(item => item.Module.module_name == userPermissionList.listSocialMediaSubmission);            
          this.setState({ listSocialMediaSubmissionFlag: listSocialMediaSubmission ? listSocialMediaSubmission.value : true,});
      }
    
  }

  
  loadSubscribeToPetByTime(selecFieldType){
    //load this week subscribe to pet records
    let startDate = moment().weekday(1).format('YYYY-MM-DD');
    let endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
    let timeDuration = {
      startDate : startDate,
      endDate : endDate
     };
    this.setState({ timeDuration : 'this_week' });
    this.loadSubscribers(selecFieldType,timeDuration);
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.subscribeToPetReducer.subscribeToPet !==
      this.props.data.subscribeToPetReducer.subscribeToPet
    ) {
      let socialMediaSubmissions = nextProps.data.subscribeToPetReducer.subscribeToPet;

      this.setState({
        socialMediaSubmissions: socialMediaSubmissions,
        loadingBd: false,
      });
    }

    if (this.props.data.subscribeToPetReducer.deletedSubscriber !== nextProps.data.subscribeToPetReducer.deletedSubscriber) {
      this.setState({loadingDelete: false});
      NotificationManager.success("Subscriber Deleted Successfully");
      this.props.fetchSubscribeToPet(this.state.selectedTab);
      $("#confirm_delete_modal").modal("hide");
    }

    if (this.state.selectedTab !== nextProps.match.params.option) {  
      this.loadSubscribeToPetByTime(nextProps.match.params.option);
    }
    
    if (this.props.data.subscribeToPetReducer.updatedSubscribedToPetRecord !== nextProps.data.subscribeToPetReducer.updatedSubscribedToPetRecord) {    
      NotificationManager.success("Subscribe to pet record updated successfully");
      $("#notes-edit-modal").modal("hide"); 
      this.setState({loadingSubscribedToPetsUpdate: false});
      this.changeTimeOption({ value : this.state.timeDuration});
    } 
    
    if (this.props.data.subscribeToPetReducer.updatedSubscribedToPetRecordError !== nextProps.data.subscribeToPetReducer.updatedSubscribedToPetRecordError) {       
      $("#notes-edit-modal").modal("hide"); 
      this.setState({loadingSubscribedToPetsUpdate: false});
      NotificationManager.error("An error occurred while updating the subscribe to pet record");
    } 
  };

  async openConfirmModel(id){
    await this.setState({deleteId: id})
    $("#confirm_delete_modal").modal("show");
  }

  async deleteSubscriber(id){
    await this.setState({loadingDelete: true});
    await this.props.deleteSubscriber(id);
  }

  async componentDidUpdate(prevProps, prevState) {}

  items = [{ title: "Subscribe To Pet", to: "/subscribe-to-pets/mobileNo" }];

  async loadSubscribers(option,timeDuration){
    this.setState({ selectedTab: option, timeFilterType : timeDuration });
    this.props.fetchSubscribeToPet(option,timeDuration);
  }
  
  openMessageSubscribers(e){
    this.setState({messageSubscribers: true})
    $('#message-to-subscribers').modal('show');
  }

  
  changeVal = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  changeTimeOption = timeOption => { 
    if(timeOption && timeOption.value){
      let startDate = 'null_date';
      let endDate = 'null_date';
      this.setState( { timeDuration : timeOption.value });
      if(timeOption.value === TIMEDURATION.THIS_WEEK ){
          //Get first date of monday
        startDate = moment().weekday(1).format('YYYY-MM-DD');
        endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
      }
      else if(timeOption.value === TIMEDURATION.LAST_WEEK){    
        startDate = moment().weekday(-6).format('YYYY-MM-DD');
        endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
      }else{
        startDate = 'null_date';
        endDate = 'null_date';
      }
      let timeDuration = {
       startDate : startDate,
       endDate : endDate
      }
      let selectedFieldType = this.state.selectedTab;
      this.props.fetchSubscribeToPet(selectedFieldType,timeDuration);
    }
  }

  openNotesEditModal = (e,row) => {
    e.preventDefault();
    if(row && row.id){
      let notes = row.contactNotes ? row.contactNotes : "";
      this.setState({ subscribedToPetId : row.id, subscribedNotes : notes });
      $("#notes-edit-modal").modal("show"); 
    }
  }

  submitNotes = () => {
    let subscribedToPetId = this.state.subscribedToPetId;
    if(subscribedToPetId){
      let data = {
        contactNotes : this.state.subscribedNotes
      }
      this.setState( { loadingSubscribedToPetsUpdate : true });
      this.props.updateSubscribedToPet(subscribedToPetId,data);
    }else{
      NotificationManager.warning("Subscribe to pet record not found");
    }
  }

  render() {
    const { timeDuration,subscribedNotes,loadingSubscribedToPetsUpdate } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Subscribe To Pet
                        <small>List of all the pet subscriptions</small>
                      </h3>
                    </div>
                  </div>  
                  <div className="medical-record-button-container" style={{width: "62%", marginTop: 18, padding: 0}}>
                    <ul
                      className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                      role="tablist"
                    >
                      <li className="nav-item m-tabs__item">
                        <NavLink
                            className={classnames({
                              "m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill": true,
                                active: false
                            })}
                            to={`/subscriber-replies`}
                        >
                          <span>
                              <i class="las la-reply"></i>
                              <span>Subscriber Replies</span>
                          </span>
                        </NavLink>
                      </li>
                      <li className="nav-item m-tabs__item">
                        <NavLink
                            className={classnames({
                              "m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill": true,
                              active: false
                            })}
                            to={`/subscribe-messages`}
                        >
                          <span>
                            <i class="las la-bell"></i>
                            <span>Notification Status</span>
                          </span>
                        </NavLink>
                      </li>
                      <li className="nav-item m-tabs__item">
                        <button
                            className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill message-subscribers-btn"
                            onClick={(e) => this.openMessageSubscribers(e)}
                        >
                            <span>
                              <i class="las la-percentage"></i>
                              <span>Message Subscribers</span>
                            </span>
                        </button>
                      </li>    
                      <li className="nav-item m-tabs__item">
                        <div style={{width: "150px"}}>
                          <Select
                            options={timeOptions}
                            value={timeDuration}
                            name="timeDuration"
                            onChange={this.changeTimeOption}
                            placeholder="Select The Time"
                          />
                        </div>
                      </li>             
                    </ul>       
                  </div>           
                </div>
                <div className="m-portlet__body medical-record-content subscribe-to-pet-table">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-to-pets/mobileNo`}
                          onClick={()=>this.setState({ loadingBd : true })}
                      >
                        Mobile No
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-to-pets/pet`}
                          onClick={()=>this.setState({ loadingBd : true })}
                      >
                        Pet
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-to-pets/breed`}
                          onClick={()=>this.setState({ loadingBd : true })}
                      >
                        Breed
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscriber-replies`}
                      >
                        Subscriber replies
                      </NavLink>
                    </li>         
                  </ul>
                  <div className="tab-content">
                    { !this.state.loadingBd ?
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.socialMediaSubmissions}
                      columns={this.state.selectedTab === "pet" ? this.tableHeaderTopPetColumnData : this.state.selectedTab === "mobileNo" ? this.tableHeaderTopColumnData : this.tableHeaderTopBreedColumnData }
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the subscribe replies, please make sure your
                              cache is cleared and completed a hard refresh. IOS users might have to use a private
                              window.
                            </small>
                          </div>
                          <BootstrapTable 
                            classes="petTable" 
                            {...props.baseProps} 
                            pagination={paginationFactory()}
                            expandRow={ this.expandRow } 
                          />
                        </div>
                      )}
                    </ToolkitProvider>:
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                    }

                  </div>
                </div>
              </div>

                {/* delete model start */}
                <div
                  className="modal fade"
                  id="confirm_delete_modal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="ConfirmationModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Confirm to delete
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <p>
                          Are you sure you want to delete this subscriber?
                        </p>
                      </div>
                      <div className="modal-footer">
                        {this.state.loadingDelete == false ? (
                          <div>
                            <button
                              type="button"
                              className="btn btn-secondary m-btn--pill mx-2"
                              data-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              onClick={() => this.deleteSubscriber(this.state.deleteId)}
                              className="btn btn-primary m-btn--pill"
                            >
                              Confirm
                            </button>
                          </div>
                        ) : (
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>  

                {/* Contact notes edit start */}
                <div className="modal fade show" id="notes-edit-modal" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Edit Notes</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="form-group m-form__group">
                          <label for="exampleTextarea">Notes</label>
                          <textarea 
                            className="form-control m-input m-input--air" 
                            id="subscribedNotes"
                            rows="3"                
                            name="subscribedNotes"
                            onChange={this.changeVal}   
                            placeholder=""
                            value={subscribedNotes}                    
                          >
                          </textarea>
                        </div>
                      </div>
                      <div className="modal-footer">   
                      { !loadingSubscribedToPetsUpdate ?           
                        <div>
                          <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                          <button type="button" onClick={() => this.submitNotes()} className="btn btn-primary m-btn--pill">Submit</button>
                        </div>:
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                      }               
                      </div>
                    </div>
                  </div>
                 </div>
                {/* Contact notes edit end */} 

                <MessageToSubscribers openClose={this.state.messageSubscribers} />
            </div>
          </div>
        </div>

             
      </div>
      
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSubscribeToPet: (field,time) => {
    dispatch(fetchSubscribeToPet(field,time));
  },
  deleteSubscriber: (id) => {
    dispatch(deleteSubscriber(id));
  },
  updateSubscribedToPet: (id,data) => {
    dispatch(updateSubscribedToPet(id,data));
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
